import client from './main-client';

export const addRevenueApi = (data) => client().post('/revenue', data);

export const editRevenueApi = (data) => client().put(`/revenue/${data.id}`, data);
